import React from "react";
import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import banner from '../assets/tractors-night1.png';
import JobDetailSection from "./JobDetailSection";

const TitleImage = styled('img')`
    height: auto;
    width: 100vw;
    margin-bottom: 0;
`;

const JobDetail = () => {

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
                <TitleImage src={banner} alt="Night Tractor Logo" />
                <Grid item md={2} xs={12} sx={{ order: { md: 1, xs: 2 } }}></Grid>
                <Grid item md={8} xs={12} sx={{ order: { md: 2, xs: 1 } }}>
                    <JobDetailSection />
                </Grid>
                <Grid item md={2} xs={12} sx={{ order: { md: 3, xs: 3 } }}></Grid>
            </Grid>
        </Box>
    )
}

export default JobDetail;